import React from "react";
import Loader from 'react-loader-spinner'
import { getBoundingClientRect } from "../../utils/functions";
import HttpService from '../../utils/Http.services';
import { checkTextTranslation, getObject, imageAddress, translate } from "../../utils/useful";
import FixedView from "../FixedView";


class CheckBoxListInput extends React.Component {

    state = {
        isOpen: false,
        data: [],
        title: '',
        tempData: [],
        options: [],
        isLoading: false,
        choosen: [],
        lastNewId: 0

    }

    // toggleOpen = (open) => {
    //     // console.log("HERE")
    //     let openState = open != null ? open : !this.state.isOpen

    //     if (openState) {
    //         // document.addEventListener('mousedown', this.fixedView.hideView);
    //         // window.addEventListener('scroll', this.fixedView.showView, true);
    //         // this.getPosition()
    //         this.fixedView.showView()

    //     } else {
    //         // document.removeEventListener('mousedown', this.fixedView.hideView);
    //         // window.removeEventListener('scroll', this.fixedView.showView);
    //         this.fixedView.hideView()


    //     }


    //     // this.refs.icon.classList.toggle("rotate-180")

    //     this.setState({ isOpen: openState, data: this.props.data })

    // }

    closeBox = (event) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.isOpen) {
            this.setState({ isOpen: false, data: this.props.data })
            document.removeEventListener('mousedown', this.closeBox);
            window.removeEventListener('scroll', this.getPosition);

            // this.refs.icon.classList.toggle("rotate-180")

        }
    }


    getPosition = () => {
        // console.log("getPosition")
        let rect = getBoundingClientRect(this.wrapperRef)
        this.setState({ top: rect.top + 35, left: rect.left - 10 })
    }


    changeItem = (prop, selected, dontChangeValue) => {

        let required = this.props.header.information.required
        // console.log("CHANGE")
        var choosen = this.state.choosen
        this.setState({ title: '' }, () => {
            if (this.refs.input)
                this.refs.input.focus()
        })

        if (selected) {
            if (this.props.header.information.multiple) {
                for (let i = 0; i < choosen.length; i++) {

                    if (choosen[i].value == prop.value) {
                        choosen.splice(i, 1)
                    }
                }
            } else {
                if (!required) {
                    choosen = null
                }
            }
        } else {
            if (this.props.header.information.multiple) {
                choosen.push(prop)
            } else {
                choosen = prop
            }
        }
        // if(!this.props.header.information.multiple ) {
        //     choosen = (prop)
        // }
        this.setState({ choosen }, () => {
            if (!dontChangeValue) this.changeValue()
        })

        setTimeout(() => {
            // this.toggleOpen(true)
        }, 1);

        // setTimeout(
        //     function () {
        //         this.toggleOpen()
        //     }
        //         .bind(this),
        //     1
        // );


        if (this.state.tempData.length > 0)
            this.setState({ options: this.state.tempData })

        // this.changeFilter(prop.value)

    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }


    componentDidMount() {
        this.mounted = true
        // console.log(this.props.data)
        this.init()

    }

    componentDidUpdate(prevProps) {
        // console.log(this.props.data)

        // if (prevProps.data != this.props.data && this.mounted) {
        //     // this.init()
        // }

        if (JSON.stringify(this.props.rowData) != JSON.stringify(this.state.rowData) && this.props.header.information.rowDependant === true) {
            // this.setState({ options: this.props.header.information.items })
            this.init()
        }

        if (JSON.stringify(this.props.data) != JSON.stringify(prevProps.data)) {
            // this.setState({ options: this.props.header.information.items })
            this.init()
        }
    }

    componentWillUnmount() {
        this.mounted = false
    }


    init() {

        // console.log(this.props.data)
        if (this.props.header.information) {
            if (this.props.header.information.type == "local") {

                let options = this.props.header.information.items
                let fields = this.props.header.information.fields
                if (fields && this.props.header.information.items) {
                    options = []

                    this.props.header.information.items.forEach(item => {
                        options.push({ title: getObject(item, fields.title), value: getObject(item, fields.value) })
                    });
                }

                let filter = { ...this.props.header.information.filter }
                let optionsFilter = {}


                for (const [key, value] of Object.entries(filter)) {
                    if (/\{\{(.*?)\}\}/.test(value)) {

                        let baseValue = value.replace(/{/g, '').replace(/}/g, '')

                        if (key.startsWith('*row') && this.props.rowData) {

                            optionsFilter[key.replace('*row.', '')] = getObject(this.props.rowData, baseValue)

                        } else {

                            if (getObject(this.props.fullData, baseValue)) {
                                // console.log(getObject(this.props.fullData, baseValue))
                                optionsFilter[key] = getObject(this.props.fullData, baseValue)

                            } else if (this.props.variables && this.props.variables[baseValue]) {
                                optionsFilter[key] = this.props.variables[baseValue]
                            } else {
                                return
                            }
                        }
                    }
                }



                let filtered = options?.filter(option => {
                    return Object.keys(optionsFilter).reduce((acc, filter) => {
                        const filterValues = optionsFilter[filter];
                        const optionValue = option[filter];


                        //This line defines what is your match
                        const found = filterValues == optionValue

                        return acc && found;
                    }, true);
                })


                let dataValue
                let choosen
                // if (this.props.data) {
                dataValue = this.props.data ? (typeof this.props.data == "object" ? (this.props.data._id ?? this.props.data.id) : this.props.data) : null
                let found = false
                filtered?.forEach(element => {
                    if (element.value == dataValue) {
                        found = true
                        choosen = element
                    }
                })

                if (!found && this.props.data) {
                    this.props.changeValue(this.props.header.key, null, this.props.extra)
                }

                this.setState({ options, choosen })
            } else if (this.props.header.information.type == "api") {
                // console.log(this.props.title)
                this.fetch()
            }
        }
    }


    fetch() {
        this.setState({ isLoading: true })
        let address = this.props.header.information.address
        let filter = typeof this.props.header.information.filter == "string" ? JSON.parse(this.props.header.information.filter) : this.props.header.information.filter

        for (const [key, value] of Object.entries(filter)) {
            if (/\{\{(.*?)\}\}/.test(value)) {
                if (this.props.variables) {
                    filter[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                }
            }
        }
        console.log(filter)


        HttpService.request(address, filter, (fetchResult, fetchError) => {
            console.log(fetchError)
            if (fetchError) { return }

            console.log(fetchResult)
            // fetch(address, {
            //     method: 'POST',
            //     body: JSON.stringify(filter),
            //     headers: headers
            // }).then(response => response.json()).then(data => {
            // console.log(data)
            // if (data.status == 200 && this.mounted) {
            var newData = []
            fetchResult.info.forEach(element => {

                var newTitle = this.spliter(element, this.props.header.information.fields.title)
                var newValue = this.spliter(element, this.props.header.information.fields.value)

                newData.push({ value: newValue, title: newTitle })
                // var newTitle = this.spliter(element, this.props.header.information.fields.title)
                // var newValue = this.spliter(element, this.props.header.information.fields.value)

                // newData.push({ value: newValue, title: newTitle })
            });

            // console.log(this.props.data)

            if (Array.isArray(this.props.data)) {
                let choosen = []
                this.props.data.forEach(oneTitle => {
                    let oneTitleId = typeof oneTitle == 'object' ? oneTitle._id : oneTitle
                    newData.forEach(oneNewData => {

                        if (oneNewData.value == oneTitleId) {
                            choosen.push({ title: oneNewData.title, value: oneTitleId })
                        }
                    });

                })
                this.setState({ choosen })
                // console.log(choosen)


            }

            this.setState({
                options: newData,
                isLoading: false
            })
        })

        // }).catch(error => this.setState({ error, isLoading: false }));
    }


    spliter(source, string) {
        var stringArray = string.split('.')
        var finalString = source
        stringArray.forEach(element => {
            finalString = finalString[element]
        });
        return finalString
    }


    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] == condition) {
                return true
            }
        }
        return false
    }


    search = async (value) => {

        // console.log(value)
        this.setState({ title: value })
        if (!this.state.isOpen) {
            // this.toggleOpen()
        }

        if (value == "") {
            await this.setState({ options: this.state.tempData })
            await this.setState({ tempData: [] })
        } else {
            if (this.state.tempData.length == 0) {
                await this.setState({ tempData: this.state.options })
            }
            var values = []
            // var values = this.props.data.filter((e) => e.title === value)
            // console.log(this.state.tempData)
            this.state.tempData.forEach(element => {
                if (String(element.title).toLowerCase().includes(String(value).toLowerCase())) {
                    values.push(element)
                }
            })
            // console.log(values)

            this.setState({ options: values })

            // }
        }
    }


    removeItem(index) {
        let choosen = [...this.state.choosen]
        choosen.splice(index, 1)
        this.setState({ choosen }, () => {
            this.changeValue()
        })
    }


    addTag() {
        let tempData = [...this.state.tempData]
        let choosen = [...this.state.choosen]

        let item = { title: this.state.title, value: this.state.title }
        tempData.push(item)
        // choosen.push(item)
        this.setState({ tempData }, () => {
            this.changeItem(item, false)
        })
        this.refs.input.focus()
    }

    changeValue() {
        let choosen = []
        if (Array.isArray(this.state.choosen)) {

            this.state.choosen.forEach(element => {
                choosen.push((typeof element.value == 'object' ? element.value._id : element.value))
                // choosen.push((element.value))

            });

        } else {
            if (this.state.choosen) {
                choosen = (this.state.choosen && typeof this.state.choosen.value == 'object') ? this.state.choosen.value?._id : this.state.choosen.value
            } else {
                choosen = null
            }
        }
        // console.log('CHOOSEN', choosen)

        // console.log(choosen)
        this.props.changeValue(this.props.header.key, choosen, this.props.extra)
    }


    render() {

        return (
            <>
                {/* <div ref={el => this.currentNode = el} className='mt-0 w-100 h-100 flexc' style={{ position: 'relative' }} onClick={() => { if (!this.props.data || typeof this.props.data != 'object') { this.toggleOpen(true) } }} >
                    <span style={{ opacity: 0 }}>0</span>
                    {this.props.header.information.placeholder && !this.state.choosen?.length && (
                        <div className="h-100 flexc" style={{ position: 'absolute', top: 0 }}>
                            <label className={' mrd-1 mld-1 placeholder '}>{checkTextTranslation(this.props.header.information.placeholder)}</label>
                        </div>
                    )}
                    <div className="wrapper w-100"  >
                        <div style={{ flexWrap: 'wrap', borderRadius: 4, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                            {this.state.isLoading && (

                                <div style={{ position: 'absolute', top: 0, right: 5 }}>
                                    <Loader
                                        type="Oval"
                                        color="rgba(0,122,255,1)"
                                        height="20"
                                        width="20"
                                    />
                                </div>
                            )}
                            {this.state.isFinal && (<i className="fa fa-check-circle mld-1" style={{ color: '#78b2d0', fontSize: 20 }}></i>)}
                        </div>
                    </div>
                </div> */}
                <div className="w-100 d-flex" >
                    <div className={''} style={{ display: 'flex', flexDirection: 'column', width: '100%', borderColor: '#eee', borderRadius: 4, maxHeight: '100%', overflow: 'auto' }}>
                        {this.props.header.information.isSearchable && (<input onChange={event => this.search(event.target.value)} placeholder={translate("placeholders.search")} style={{ fontSize: 13, alignSelf: 'stratch', padding: 5, margin: 5, height: 35, backgroundColor: '#f7f7f7', borderRadius: 4, borderWidth: 1, borderStyle: 'solid', borderColor: '#eee', marginTop: 5 }} className={'text-start'} />)}
                        {this.state.options.map((prop, index) => {
                            let selected = false
                            if (Array.isArray(this.state.choosen)) {
                                for (var i = 0; i < this.state.choosen.length; i++) {
                                    if (prop.value == this.state.choosen[i].value)
                                        selected = true
                                }
                            } else {
                                if (this.state.choosen?.value == prop.value) {
                                    selected = true
                                }
                            }
                            return (
                                <div className="flexc" key={index} onClick={() => this.changeItem(prop, selected)} style={{ cursor: 'pointer', padding: 5, paddingTop: 10, paddingBottom: 10, borderBottomColor: '#eee', borderBottomStyle: 'solid', borderBottomWidth: 1, backgroundColor: selected ? '#f7f7f7' : '#fff' }}>
                                    <input className="mrd-1" checked={selected} type="checkbox" />

                                    {this.props.header.information.showImage && (
                                        <div className="mld-3">
                                            <div className=" flexcc" style={{}}>
                                                <img src={imageAddress(prop?.image, "profile", 'thumb')} style={{ width: 30, height: 30, borderRadius: 30, objectFit: 'cover' }} />
                                            </div>
                                        </div>
                                    )}
                                    <div className="px-2 w-100">
                                        <div className="flexcb w-100">
                                            <p className="mb-0 text-semibold" style={{ fontSize: 13, color: '#202020' }}>{prop?.title}</p>
                                        </div>
                                        <p className="" style={{ color: '#567', fontSize: 11 }}>{prop.description}</p>
                                    </div>
                                </div>
                            )
                        })}
                        {this.state.options.length == 0 && (
                            <div style={{ cursor: 'pointer', padding: 5, paddingTop: 10, paddingBottom: 10, borderBottomColor: '#eee', borderBottomStyle: 'solid', borderBottomWidth: 1 }}>
                                <p style={{ textAlign: 'center', margin: 0, color: '#000', opacity: 0.5, fontSize: 13 }}>{translate("useful.foundNothing")}</p>
                                {this.props.header.information.tag && this.state.title != '' && (<p onClick={() => this.addTag()} style={{ textAlign: 'center', margin: 0, color: '#007aff', fontSize: 13, marginTop: 5, marginBottom: 5, cursor: 'pointer' }}>+ ADD THIS</p>)}

                            </div>
                        )}

                    </div>
                </div>
            </>

        );
    }
}


export default CheckBoxListInput;
